import { createReducer } from "./functions";
import {
	MENU_TOP_INDEX,
	MENU_LEFT_INDEX,
	MENU_LEFT_ITEM_INDEX,
	MENU_LEFT_CONTENT,
} from "./../actions/menuActions";

const initialState = {
	menuTopIndex: "",
	menuLeftIndex: "",
	menuLeftItemIndex: "",
	menuLeftContent: "",
};

const menus = {
	[MENU_TOP_INDEX]: (state, action) => {
		return { ...state, menuTopIndex: action.index };
	},
	[MENU_LEFT_INDEX]: (state, action) => {
		return { ...state, menuLeftIndex: action.index };
	},
	[MENU_LEFT_ITEM_INDEX]: (state, action) => {
		return { ...state, menuLeftItemIndex: action.index };
	},
	[MENU_LEFT_CONTENT]: (state, action) => {
		return { ...state, menuLeftContent: action.data };
	},
};

const appReducer = createReducer(initialState, {
	...menus,
});

export default appReducer;



// WEBPACK FOOTER //
// src/redux/reducers/appReducer.js